<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!--title -->
      <div class="grid-title no-border borderTop">
        <h4 style="padding-left: 6px">{{ i18nValues["productEdition"] }}</h4>
      </div>

      <!-- body -->
      <div class="grid-body no-border borderBottom">
        <el-form
          v-loading="loading != 0"
          :model="product"
          ref="formProduct"
          :rules="rules"
        >
          <div class="gridTemplate">
            <!-- Product Experimental Code -->
            <el-form-item
              :label="i18nValues['experimentalCode']"
              prop="experimentalCode"
            >
              <el-input
                v-model="product.experimentalCode"
                maxlength="30"
              ></el-input>
            </el-form-item>

            <!-- Product Name -->
            <el-form-item label="Variety" prop="name">
              <el-input v-model="product.name" maxlength="30"></el-input>
            </el-form-item>

            <!-- Product Brand-->
            <el-form-item label="Brand" prop="brand">
              <el-input v-model="product.brand" maxlength="30"></el-input>
            </el-form-item>

            <!-- Event -->
            <div class="gridTemplate">
              <el-form-item :label="i18nValues['event']" prop="event">
                <el-select
                  v-model="product.event"
                  placeholder="Please select"
                  value-key="id"
                  filterable
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in EventsList"
                    :key="item.id"
                    :label="item.name + '   ' + item.detailedTrait"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- Product CropType -->
              <el-form-item :label="i18nValues['crop']" prop="cropType">
                <el-select
                  v-model="product.cropType"
                  :placeholder="i18nValues['crop']"
                >
                  <el-option
                    v-for="item in variedades"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <!-- Product GM-->
            <el-form-item :label="i18nValues['gm']" prop="gm">
              <el-input v-model="product.gm" maxlength="6"></el-input>
            </el-form-item>

            <!-- Product Flower-->
            <el-form-item :label="i18nValues['flower']" prop="flower">
              <el-input v-model="product.flower" maxlength="30"></el-input>
            </el-form-item>

            <!-- Product Pod-->
            <el-form-item :label="i18nValues['pod']" prop="pod">
              <el-input v-model="product.pod" maxlength="30"></el-input>
            </el-form-item>

            <!-- Product Pub-->
            <el-form-item :label="i18nValues['pub']" prop="pub">
              <el-input v-model="product.pub" maxlength="30"></el-input>
            </el-form-item>

            <!-- Product Hilum-->
            <el-form-item :label="i18nValues['hilum']" prop="hilum">
              <el-input v-model="product.hilum" maxlength="30"></el-input>
            </el-form-item>

            <!-- Product STS-->
            <el-form-item :label="i18nValues['sts']" prop="sts">
              <el-input v-model="product.sts" maxlength="30"></el-input>
            </el-form-item>

            <!-- Product Main Features-->
            <el-form-item
              :label="i18nValues['mainFeatures']"
              prop="mainFeatures"
            >
              <el-input
                v-model="product.mainFeatures"
                type="textarea"
                :autosize="{ minRows: 2 }"
              ></el-input>
            </el-form-item>

            <!-- Cross Campaign -->
            <el-form-item
              :label="i18nValues['crossCampaign']"
              prop="crossCampaign"
            >
              <el-checkbox v-model="product.crossCampaign">
              </el-checkbox>
            </el-form-item>
          </div>
        </el-form>

        <!-- CANCEL/SAVE -->
        <div class="full-width d-flex justify-content-end mt-2">
          <el-button
            :loading="loading"
            size="small"
            @click="cancel()"
          >
            {{ i18nValues["cancel"] }}
          </el-button>
          <el-button
            v-if="!isReadOnly()"
            icon="fas fa-check"
            :loading="loading"
            size="small"
            class="btn-primary"
            @click="save()"
          >
            {{ i18nValues["save"] }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
export default {
  name: "ProductEdition",

  created() {
    if (this.id != 0) {
      this.retrieveById();
    } else {
      this.product.creationUser = this.user.name;
      this.product.creationDate = new Date();
    }

    this.retrieveEvents();
    // Capture initial query to preserve filters/pagination when returning
    this.returnQuery = { ...this.$route.query };

    this.rules = {
      name: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      brand: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      event: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
      nextBatch: [
        {
          required: true,
          message: this.i18nValues["requiredValue"],
          trigger: "blur",
        },
      ],
    };
  },

  components: {},

  computed: {
    loading: get("product/loading"),
    globalCampaign: get("globalCampaign"),
  },

  props: ["id"],

  data() {
    return {
      product: {
        event: null,
      },

      EventsList: [],

      variedades: [
        { value: "corn", label: "Corn Seed" },
        { value: "soy", label: "Soybean Production" },
        { value: "soyRD", label: "Soybean R&D" },
      ],

      CrossCampaignOptions: [
        { value: "yes", label: "Si" },
        { value: "no", label: "No" },
      ],
      returnQuery: {},
    };
  },

  methods: {
    save() {
      this.$refs.formProduct.validate((valid) => {
        if (valid) {
          this.product.campaign = {
            id: this.globalCampaign ? this.globalCampaign.id : null,
          };
          this.$store
            .dispatch("product/saveProduct", this.product)
            .then((res) => {
              if (res.status == "OK") {
                this.$notify.success({
                  title: this.i18nValues["succes"],
                  message: this.i18nValues["productSaved"],
                  position: "bottom-right",
                });
                this.$router.push({ name: "ProductAdmin", query: this.returnQuery });
              } else {
                this.$notify.error({
                  title: this.i18nValues["error"],
                  message: this.i18nValues["productSavedError"],
                  position: "bottom-right",
                });
              }
            });
        }
      });
    },

    cancel() {
      this.$router.push({ name: "ProductAdmin", query: this.returnQuery });
    },

    retrieveById() {
      this.$store
        .dispatch("product/retrieveProductById", { id: this.id })
        .then((res) => {
          this.product = res;
          this.product.modificationUser = this.user.name;
          this.product.modificationDate = new Date();
        });
    },

    retrieveEvents() {
      this.$store.dispatch("event/retrieveEvents").then((res) => {
        this.EventsList = res;
      });
    },
  },
};
</script>

<style></style>
